import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form as FormikForm } from 'formik'
import * as Yup from 'yup'
import * as forms from '../../../lib/forms'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import Button from '../../commons/Button/Button'
import Text from '../../commons/Text/Text'
import TextFieldFormik from '../../commons/Fields/TextFieldFormik'
import Flex from '../../commons/Flex/Flex'
import styles from './RecoveryPasswordEmail.module.scss'

export const EMAIL_FIELD_ID = 'EMAIL_FIELD_ID'

export const INITIAL_VALUES = {
  email: ''
}

export const VALIDATION_MESSAGES = {
  email: {
    format: 'Email inválido',
    required: 'Email requerido'
  }
}

export const EmailSchema = {
  email: Yup.string()
    .required(VALIDATION_MESSAGES.email.required)
    .email(VALIDATION_MESSAGES.email.format)
}

export const RecoveryPasswordSentEmailSchema = Yup.object().shape({
  ...EmailSchema
})

const RecoveryPasswordSentEmailForm = (props) => {
  const handleRedirectToLogin = useCallback(() => {
    history.push(routes.login.path)
  }, [])
  const { handleSubmit, error } = props

  return (
    <>
      <Formik
        initialValues={INITIAL_VALUES}
        handleSubmit={handleSubmit}
        validationSchema={RecoveryPasswordSentEmailSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, isValid, setErrors, values }) => {
          useEffect(() => {
            forms.applyGeneralError(error?.hasError, values, setErrors)
          }, [error?.hasError, isSubmitting])

          return (
            <FormikForm className={styles.containerForm}>
              <TextFieldFormik
                name="email"
                validate="email"
                label="Digite seu e-mail"
              />

              <Flex justifyContent="space-between" style={{ width: '90%' }}>
                <div className={styles.containerButton}>
                  <Button
                    className={styles.button}
                    type="outlined_dark"
                    margin="12px 0 0"
                    buttonType="button"
                    width="160px"
                    onClick={handleRedirectToLogin}
                  >
                    <Text
                      font="custom"
                      color="gray"
                      variation="dark"
                      size="xs"
                      value="Voltar"
                      bold
                    />
                  </Button>
                  <Button
                    className={styles.button}
                    type="secondary"
                    margin="12px 0 0"
                    buttonType="submit"
                    disabled={!isValid}
                    width="160px"
                  >
                    <Text
                      font="custom"
                      color="white"
                      size="xs"
                      value="Recuperar"
                      bold
                    />
                  </Button>
                </div>
              </Flex>
            </FormikForm>
          )
        }}
      </Formik>
    </>
  )
}

RecoveryPasswordSentEmailForm.defaultProps = {
  handleSubmit: null,
  error: {
    hasError: false,
    messages: []
  }
}

RecoveryPasswordSentEmailForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.shape({
    hasError: PropTypes.bool,
    messages: PropTypes.arrayOf(PropTypes.string)
  })
}

export default RecoveryPasswordSentEmailForm
